<template lang="pug">
  div
    el-alert.hidden-md-and-up(effect="dark" title="目前使用手機相容模式，建議在平板或電腦上使用以獲得最佳挑課體驗" type="warning")
    a-modal(title="如果您喜歡NiceCoruseToU，請前往粉絲團按讚支持吧!" :visible="showAlert" ok-text="好的，我就按" cancel-text="我不要，交大是陽明的一部分。"
      @ok="goToPage(true)" @cancel="goToPage(false)")
      p NiceCourseToU的任務不只是為您選課，也更是延續過去的NCTU+，這段轉換期間會是非常漫長的過程。處在交大併校的轉換期，正是交大師生們需要一起凝聚起來的重要時刻。
      p 您簡單的一個讚，能使更多人發現NiceCourseToU的存在，並讓所有人團結，再造一個新的社群。未來NiceCourseToU不會只有選課的功能，也將是所有交大人的集散地之一。
      p 而為了答謝您的支持，我們未來會提供給您早期拓荒者的特殊功能喔！
    //a-alert(type="info" title="我們需要你" show-icon close-text="這種好工具只有我能用，我不想宣傳" v-show="$store.state.user.hasPressedLike !== true" @close="goToPage(false)")
        span(slot="description")
            | 如果您喜歡NiceCoruseToU，請前往粉絲團按讚支持吧，您的小舉動會讓更多人得以使用這個工具，而且未來會提供給您早期粉絲的特殊功能喔。
            a(@click="goToPage(true)") 前往粉絲團，幫未來的自己謀福利
    top-nav-bar
    dashboard.hidden-md-and-up(:md="24" :sm="24" :xs="24")

    a-layout
      //a-layout-sider(width="120" breakpoint="lg" collapsed-width="0" )
          a-menu(:default-selected-keys="['courseTable']" v-model="activeTab" @click="selectedTab" theme="dark" mode="inline")
              a-menu-item(key="courseTable")
                  a-icon(type="table")
                  span(style="font-size:8px") 課程表
              a-menu-item(key="discuss")
                  a-icon(type="team")
                  span(style="font-size:8px") 課程心得
              a-menu-item(@click="goToPage(true)")
                  a-icon(type="facebook")
                  span(style="font-size:8px") FB粉專
      a-layout(v-if="activeTab.includes('courseTable')")
        a-layout-sider.hidden-sm-and-down(width="33%")
          a-layout
            a-layout-content
              course-classified-list
            a-layout-footer
              dashboard
        a-layout-content(:xs="24" :sm="24" :md="15"  :lg="15" :xl="15" )
          //course-timetable
          course-timetable-rollback

    a-row
      a-col.hidden-md-and-up(:md="24" :sm="24" :xs="24")
        course-classified-list
</template>

<script>
import CourseTimetable from "@/components/Element/CourseTimetable";
import Dashboard from "@/components/Element/Dashboard";
import TopNavBar from "@/components/Outline/TopNavBar";
import CourseClassifiedList from "@/components/Outline/CourseClassifiedList";
import CourseTimetableRollback from "@/components/Element/CourseTimetableRollback";
import {saveSession} from "@/sessionSave";

export default {
  name: "CourseTutorMain",
  data() {
    return {
      activeTab: ["courseTable"],
      showAlert: false
    }
  },
  components: {
    CourseTimetableRollback,
    CourseClassifiedList,
    TopNavBar, Dashboard, CourseTimetable
  },
  methods: {
    goToPage(accept) {
      this.activeTab = ['courseTable']
      this.showAlert = false
      this.$store.state.user.hasPressedLike = true
      this.$store.state.user.hasWatchedRequest = true
      saveSession(this.$store.state)
      if (accept) {
        window.open('https://www.facebook.com/NiceCourseToU/')
      } else {
        this.$alert("你有權保持緘默的啦", '陽明內鬼抓到惹', {
          confirmButtonText: '...',
          cancelButtonText: '我不要'
        }).then(() =>
            window.open('https://www.facebook.com/NiceCourseToU/')
        ).catch(() =>
            window.open('https://www.facebook.com/NiceCourseToU/'))
      }
    },
    selectedTab() {
      console.log(this.activeTab)
    }
  },
  mounted() {
    if (this.$store.state.user.hasWatchedRequest !== true) {
      setTimeout(() => {
        this.showAlert = true
      }, 1000 * 25)
    }
  }
}
</script>

<style scoped>

</style>
